import actions from './actions';

const initialState = {
    bulkQrReportList: [],
    bulkQrReportLoading: false,
    searchButtonLoading: false,
    bulkQrReportError: '',

    bulkQrDetailsList: [],
    bulkQrDetailsLoading: false,
    bulkQrDetailsError: '',

};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_BULK_QR_REPORT:
            return {
                ...state,
                bulkQrReportLoading: true,
                searchButtonLoading: true,
                bulkQrReportError: '',
            };

        case actions.GET_BULK_QR_REPORT_SUCCESS:
            return {
                ...state,
                bulkQrReportLoading: false,
                searchButtonLoading: false,
                bulkQrReportList: action.payload,
            };

        case actions.GET_BULK_QR_REPORT_FAILED:
            return {
                ...state,
                bulkQrReportLoading: false,
                searchButtonLoading: false,
                bulkQrReportList: [],
                bulkQrReportError: action.payload,
            };

        case actions.GET_BULK_QR_DETAILS:
            return {
                ...state,
                bulkQrDetailsLoading: true,
                bulkQrDetailsList: [],
                bulkQrDetailsError: '',
            };

        case actions.GET_BULK_QR_DETAILS_SUCCESS:
            return {
                ...state,
                bulkQrDetailsLoading: false,
                searchButtonLoading: false,
                bulkQrDetailsList: action.payload,
            };

        case actions.GET_BULK_QR_DETAILS_FAILED:
            return {
                ...state,
                bulkQrDetailsLoading: false,
                searchButtonLoading: false,
                bulkQrDetailsList: [],
                bulkQrDetailsError: action.payload,
            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                bulkQrReportError: '',
            };

        default:
            return state;
    }
}